import { withInstall } from '@ll-plus/utils'

import ButtonGroup from './src/button-group.vue'
import Button from './src/button.vue'

export const LlButton = withInstall(Button)
export const LlButtonGroup = withInstall(ButtonGroup)

export * from './src/button'

declare module 'vue' {
  export interface GlobalComponents {
    LlButton: typeof Button
    LlButtonGroup: typeof ButtonGroup
  }
}
